import { lazy } from "react";

export interface ToolDefinition {
  name: string;
  title: string;
  /** Date first added to the site (YYYY-MM-DD), backfilled from Git history. */
  createdAt: string;
  desc?: string;
  icon?: string;
  component?: any;
}

export const toolDefinitions: ToolDefinition[] = [
  {
    name: "timeZoneConverter",
    createdAt: "2026-10-18",
    title: "Time Zone Converter",
    icon: "\uD83C\uDF10",
    desc: "Convert dates and times between time zones with daylight saving handling",
    component: lazy(() => import("./timeZoneConverter/TimeZoneConverter"))
  },
  {
    name: "cronExpressions",
    createdAt: "2026-10-18",
    title: "Cron Expressions",
    icon: "\u23F0",
    desc: "Build cron schedules and translate expressions into plain English",
    component: lazy(() => import("./cronExpressions/CronExpressions"))
  },
  {
    name: "energyCalculator",
    createdAt: "2026-09-19",
    title: "Energy Calculator",
    icon: "\u26A1",
    desc: "Compare Australian electricity and gas rates, discounts, and yearly costs",
    component: lazy(() => import("./energyCalculator/EnergyCalculator"))
  },
  {
    name: "listRandomizer",
    createdAt: "2024-09-29",
    title: "List Randomizer",
    icon: "\uD83C\uDFB2",
    desc: "Shuffle and sort lists with simulation",
    component: lazy(() => import("./listRandomizer/ListRandomizer"))
  },
  {
    name: "randomJoke",
    createdAt: "2024-09-29",
    title: "Random Joke",
    icon: "\uD83D\uDE02",
    desc: "Fetch a random joke from the API",
    component: lazy(() => import("./randomJoke/RandomJoke"))
  },
  {
    name: "compressor",
    createdAt: "2024-09-29",
    title: "Compressor",
    icon: "\uD83D\uDCE6",
    desc: "LZ-String, Zlib, and Zip compression",
    component: lazy(() => import("./compressor/Compressor"))
  },
  {
    name: "textEncoder",
    createdAt: "2024-09-29",
    title: "Text Encoder",
    icon: "\uD83D\uDD10",
    desc: "Base64, hex, binary, and ROT13 encoding",
    component: lazy(() => import("./textEncoder/TextEncoder"))
  },
  {
    name: "sample",
    createdAt: "2024-09-29",
    title: "Sample Generator",
    icon: "\uD83D\uDCCA",
    desc: "Generate random data samples",
    component: lazy(() => import("./sampleGenerator/SampleGenerator"))
  },
  {
    name: "benchMarker",
    createdAt: "2024-09-29",
    title: "Bench Marker",
    icon: "\u26A1",
    desc: "Benchmark compression and simulation",
    component: lazy(() => import("./benchMarker/BenchMarker"))
  },
  {
    name: "qrCodeGenerator",
    createdAt: "2026-03-21",
    title: "QR Code Generator",
    icon: "\uD83D\uDCF1",
    desc: "Generate QR codes from URLs or text",
    component: lazy(() => import("./qrCodeGenerator/QrCodeGenerator"))
  },
  {
    name: "jsonFormatter",
    createdAt: "2026-03-21",
    title: "JSON Formatter",
    icon: "\uD83D\uDCCB",
    desc: "Format, minify, and validate JSON",
    component: lazy(() => import("./jsonFormatter/JsonFormatter"))
  },
  {
    name: "urlEncoder",
    createdAt: "2026-04-06",
    title: "URL Encoder",
    icon: "\uD83D\uDD17",
    desc: "Encode and decode URLs",
    component: lazy(() => import("./urlEncoder/UrlEncoder"))
  },
  {
    name: "converter",
    createdAt: "2026-04-06",
    title: "Converter",
    icon: "\uD83D\uDD04",
    desc: "Convert between JSON, XML, and CSV",
    component: lazy(() => import("./converter/Converter"))
  },
  {
    name: "colorTool",
    createdAt: "2026-04-06",
    title: "Color Tool",
    icon: "\uD83C\uDFA8",
    desc: "Pick, convert, generate palettes, and check contrast",
    component: lazy(() => import("./colorTool/ColorTool"))
  },
  {
    name: "jwtDecoder",
    createdAt: "2026-05-24",
    title: "JWT Decoder",
    icon: "\uD83D\uDD11",
    desc: "Decode JWT headers, payloads, and claims",
    component: lazy(() => import("./jwtDecoder/JwtDecoder"))
  },
  {
    name: "listCompare",
    createdAt: "2026-08-29",
    title: "List Compare",
    icon: "\u2696\uFE0F",
    desc: "Compare two lists: differences, intersection, and union",
    component: lazy(() => import("./listCompare/ListCompare"))
  },
  {
    name: "combinationCalculator",
    createdAt: "2026-08-30",
    title: "Combination Calculator",
    icon: "\uD83D\uDD22",
    desc: "Count and list permutations and combinations",
    component: lazy(
      () => import("./combinationCalculator/CombinationCalculator")
    )
  }
];
